import PropTypes from 'prop-types';
import React from 'react';

import SortableCard from '../../Card/SortableCard';
import CardContainer from '../../../../containers/CardContainer'; // ─── C2 : mode readOnly ───

import IdBadge from '../../../../ui/IdBadge';
import styles from './SubtaskGroup.module.scss';

const SubtaskGroup = React.memo(
  ({ parentId, parentName, childIds, listId, canEdit, readOnly, onSortableReady }) => {
    // Nom tronqué (cohérent avec le badge #4)
    const label =
      parentName && parentName.length > 22 ? `${parentName.slice(0, 22)}…` : parentName || '';

    return (
      <div className={styles.wrapper}>
        <div className={styles.header} title={parentName || ''}>
          <IdBadge id={parentId} size="small" />
          <span className={styles.name}>{label}</span>
        </div>
        <div className={styles.body}>
          {childIds.map((cardId) =>
            readOnly ? (
              // ─── C2 : niveaux ≥ 1 → non déplaçable (pas de DragDropProvider) ───
              <div key={cardId} className={styles.readOnlyCard}>
                <CardContainer id={cardId} hideParent />
              </div>
            ) : (
              // ─── niveau 0 → déplaçable (DnD) ───
              <SortableCard
                key={cardId}
                id={cardId}
                listId={listId}
                canEdit={canEdit}
                hideParent
                onSortableReady={onSortableReady}
              />
            ),
          )}
        </div>
      </div>
    );
  },
);

SubtaskGroup.propTypes = {
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  parentName: PropTypes.string,
  childIds: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  listId: PropTypes.string, // ─── C2 : optionnel en readOnly ───
  canEdit: PropTypes.bool, // ─── C2 : optionnel en readOnly ───
  readOnly: PropTypes.bool, // ─── C2 ───
  onSortableReady: PropTypes.func, // ─── C2 : optionnel en readOnly ───
};

SubtaskGroup.defaultProps = {
  parentName: '',
  listId: null,
  canEdit: false,
  readOnly: false,
  onSortableReady: () => {},
};

export default SubtaskGroup;
